;
export default class Form {
    constructor(configuration) {
        this._id = configuration.id;
        this.route = configuration.route;
        this.data = configuration.data;
        this.recaptchaAction = configuration.recaptchaAction;
        this.preRequestCallback = configuration.preRequestCallback;
        this.successCallback = configuration.successCallback;
        this.errorCallback = configuration.errorCallback;
        this._formElement = document.querySelector(`[data-form="${this._id}"]`);
        if (this._formElement == null)
            return;
        this._submitButtonElement = this._formElement.querySelector('[data-form="submit"]');
        this._submitButtonElement.addEventListener('click', event => this._submit(event));
    }
    ;
    async _submit(event) {
        event.preventDefault();
        const formData = new FormData(this._formElement);
        const details = {};
        this.data.forEach(field => details[field] = formData.get(field));
        if (this.preRequestCallback != null && !(this.preRequestCallback(details)))
            return;
        if (this.recaptchaAction != null)
            details.recaptchaToken = await new Promise((resolve, reject) => {
                grecaptcha.ready(() => grecaptcha
                    .execute(this._formElement.dataset.recaptchaSiteKey, { 'action': this.recaptchaAction })
                    .then(resolve, reject));
            });
        const response = await fetch(this.route, {
            'method': 'POST',
            'headers': {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            'body': JSON.stringify(details),
        });
        let responseDetails = {
            'status': response.status,
            'headers': response.headers,
        };
        let callback;
        if (response.status >= 200 && response.status < 300)
            callback = this.successCallback;
        else
            callback = this.errorCallback;
        const contentType = response.headers.get('content-type');
        if (contentType !== null && contentType.indexOf('application/json') !== -1) {
            responseDetails.type = 'json';
            return callback(await response.json(), responseDetails);
        }
        else if (contentType !== null) {
            responseDetails.type = 'text';
            return callback(await response.text(), responseDetails);
        }
        return callback(responseDetails);
    }
    ;
}
;
